module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "historico-lances sys-table"
  }, [_c('div', {
    staticClass: "table-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.lote.lances), function(lance) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "col-apelido"
    }, [_vm._v(_vm._s(lance.arrematante.apelido))]), _vm._v(" "), _c('div', {
      staticClass: "col-data"
    }, [_vm._v(_vm._s(_vm.moment(lance.data.date).format('L')) + " " + _vm._s(_vm.moment(lance.data.date).format('LTS')))]), _vm._v(" "), _c('div', {
      staticClass: "col-valor"
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lance.valor)))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "col-apelido"
  }, [_vm._v("Apelido")]), _vm._v(" "), _c('div', {
    staticClass: "col-data"
  }, [_vm._v("Data")]), _vm._v(" "), _c('div', {
    staticClass: "col-valor"
  }, [_vm._v("Valor")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a09c0260","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/HistoricoLances.vue
// module id = 845
// module chunks = 2